<style scoped>
    * {
        will-change: height;
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }
    .expand-enter-active,
    .expand-leave-active {
        transition: height .5s ease-in-out;
        overflow: hidden;
    }
    .expand-enter,
    .expand-leave-to {
        height: 0;
    }
</style>

<template>
    <transition
        name="expand"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
    >   
    <slot></slot>
    </transition>
</template>

<script>
    export default {
        name: 'ExpandTransition',
        methods: {
            enter(element) {
                if (Array.prototype.findIndex) {
                    const width = getComputedStyle(element).width;

                    element.style.width = width;
                    element.style.position = 'absolute';
                    element.style.visibility = 'hidden';
                    element.style.height = 'auto';

                    const height = getComputedStyle(element).height;

                    console.log('height: '+height);

                    element.style.width = null;
                    element.style.position = null;
                    element.style.visibility = null;
                    element.style.height = 0;

                    console.log('got here');
                    // Trigger the animation.
                    // We use `setTimeout` because we need
                    // to make sure the browser has finished
                    // painting after setting the `height`
                    // to `0` in the line above.
                    setTimeout(() => {
                        console.log('execute!')
                        element.style.height = height;
                        console.log(element.style.height)
                    });
                }
            },
            afterEnter(element) {
                if (Array.prototype.findIndex) {
                    element.style.height = 'auto';
                }
            },
            leave(element) {
                if (Array.prototype.findIndex) {                    
                    const height = getComputedStyle(element).height;
                    
                    element.style.height = height;

                    setTimeout(() => {
                        element.style.height = 0;
                    });
                }
            },
    },
  }
</script>